<template>
  <div class="tm-sidebar">
    <!--кнопка открытия меню-->
    <a
      data-uk-toggle
      href="#tm-menu"
      class="uk-navbar-toggle uk-position-top-left uk-position-fixed uk-button uk-button-success uk-button-large"
      style="z-index: 9998;border-radius: 0;padding: 0 15px;"
      role="button"
      aria-label="Open menu">
      <div data-uk-navbar-toggle-icon="ratio: 1.5" class="uk-icon uk-navbar-toggle-icon"></div>
      <div class="tm-navbar-toggle-icon2">
        <md-icon class="uk-light">keyboard_double_arrow_right</md-icon>
      </div>
    </a>
    <!--меню в offcanvas-->
    <div
      class="tm-menu-offcanvas uk-offcanvas"
      id="tm-menu"
      data-uk-offcanvas="mode: push; overlay: true">

      <div class="uk-offcanvas-bar uk-padding-remove" :style="{ backgroundImage: `url(${sidebarBackgroundImage})`, backgroundSize: 'cover', backgroundPosition: '50%' }">
        <button class="uk-offcanvas-close uk-close-large uk-light" type="button" data-uk-close></button>
        <div>

          <!--подключаем UserMenuV2.vue  и DashboardLayoutV2.vue-->
          <div>
            <slot></slot>
            <ul class="uk-nav uk-nav-default">
              <slot name="links">
                <sidebar-item
                    v-for="(link, index) in sidebarLinks"
                    :key="link.name + index"
                    :link="link">
                  <sidebar-item
                      v-for="(subLink, index) in link.children"
                      :key="subLink.name + index"
                      :link="subLink">
                  </sidebar-item>
                </sidebar-item>
              </slot>
            </ul>
          </div>

          <hr class="uk-margin" />

          <ul class="uk-nav uk-nav-default">
            <li>
              <a class="" href="https://t.me/anastasia_melni4uk" target="_blank">
                <div class="uk-grid uk-grid-small uk-flex-middle" data-uk-grid>
                  <div>
                    <md-icon>contact_support</md-icon>
                  </div>
                  <div class="uk-width-expand">
                    {{ local_page_keys.sidebar_link_title }}
                  </div>
                </div>
              </a>
              <div
                  class="uk-dropdown tm-dropdown tm-dropdown-bottom-center"
                  style="width: 260px;max-width: 260px;"
                  data-uk-dropdown="pos: bottom-center; offset: 15; delay-show: 200">
                {{ local_page_keys.support_dropdown_message }}
              </div>
            </li>
          </ul>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "sidebar",
  props: {
    title: {
      type: String,
      default: " "
    },

    logo: {
      type: String,
      default: `${process.env.VUE_APP_BASE_URL}/img/vue-logo.png`
    },
    sidebarLinks: {
      type: Array,
      default: () => []
    },
    autoClose: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    local_page_keys: {},
    role: '',
    hoverClassCondition: false,
    sidebarToggle: false,
    rolesWithManualSidebar: ['senior-retoucher', 'pro-retoucher', 'retoucher', 'junior-retoucher', 'test-retoucher', 'admin', 'tester'],
    sidebarBackgroundImage: process.env.VUE_APP_BASE_URL + "/img/home-bg1.jpg",
  }),
  created() {
    this.$sidebar.toggleMinimize();
    this.getRole();
  },
  provide() {
    return {
      autoClose: this.autoClose
    };
  },
  methods: {
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    async getRole() {
      await this.$store.dispatch("profile/role");
      this.role = await this.$store.getters["profile/role"];
    },
  },

  async mounted() {
    this.local_page_keys = await this.$filtergetLocalisationPage('menu');
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  }
};
</script>
<style>
  @import '../../assets/css/uikit/offcanvas.css';
  @import '../../assets/css/uikit/icon.css';
  .tm-user-menu-avatar .tm-sidebar-red-notification:after {
    top: -1px;
    left: 30px;
  }
  .tm-sidebar .uk-navbar-toggle-icon svg>[class*="line-"] {
    height: 1px;
  }
  .tm-sidebar .uk-navbar-toggle .tm-navbar-toggle-icon2 {
    opacity: 1;
    -webkit-transition: 0.1s ease-in-out;
    transition: 0.1s ease-in-out;
    position: absolute;
    top: 50%;
    left: calc(50% + 17px);
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: -webkit-max-content;
    width: -moz-max-content;
    width: max-content;
    max-width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  .tm-sidebar .uk-navbar-toggle .uk-navbar-toggle-icon {
    opacity: 0;
    transition: 0.1s ease-in-out;
  }
  .tm-sidebar .uk-navbar-toggle:hover .uk-navbar-toggle-icon {
    opacity: 1;
  }
  .tm-sidebar .uk-navbar-toggle:hover .tm-navbar-toggle-icon2 {
    opacity: 0;
    left: calc(50% + 0);
  }
  .tm-sidebar .uk-navbar-toggle {
    margin-left: -35px;
    transition: 0.1s ease-in-out;
  }
  .tm-sidebar .uk-navbar-toggle:hover {
    margin-left: 0;
  }
  .tm-sidebar hr {
    border-color: rgba(229, 229, 229, 0.3);
  }
  .tm-sidebar .uk-offcanvas-close {
    top: 10px;
    right: 10px;
  }
  .tm-sidebar .uk-nav-default > li > a {
    padding: 10px 20px;
    cursor: pointer;
    color: #fff;
    background-color: transparent;
    -webkit-transition: 0.1s ease-in-out;
    transition: 0.1s ease-in-out;
    -webkit-transition-property: color, background-color, border-color;
    transition-property: color, background-color, border-color;
  }
  .tm-sidebar .uk-nav-default > li > a .md-icon {
    color: #fff;
  }
  .tm-sidebar .uk-nav-default > li > a:hover,
  .tm-sidebar .uk-nav-default > li > a:focus {
    background-color: #fff;
    color: #333 !important;
  }
  .tm-sidebar .uk-nav-default > li > a:hover .md-icon,
  .tm-sidebar .uk-nav-default > li > a:focus .md-icon {
    color: #333;
  }

  .tm-sidebar .uk-nav-default > li > a.active {
    background-color: #4caf50;
    color: #fff !important;
  }
  .tm-sidebar .uk-nav-default > li > a.active .md-icon {
    color: #fff;
  }

  .uk-offcanvas {
    z-index: 9999;
  }
  .tm-menu-offcanvas .uk-offcanvas-bar {
    width: 300px;
  }
  @media (min-width: 960px) {
    :not(.uk-offcanvas-flip).uk-offcanvas-container-animation {
      left: 300px;
    }
  }
  .tm-menu-offcanvas .uk-offcanvas-bar > div {
    position: relative;
    z-index: 2;
  }
  .tm-menu-offcanvas .uk-offcanvas-bar:after {
    display: block;
    content: "";
    background-color: rgb(0 0 0 / 77%);
    height: 100%;
    width: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    position: absolute;
    z-index: 0;
  }
</style>
